/* eslint-disable no-undef, no-underscore-dangle */
export default function Webchat() {
    const liveagentButtonOnline = document.getElementById('liveagent_button_online');

    if (liveagentButtonOnline !== null) {
        const webchatchatDeploymentId = liveagentButtonOnline.getAttribute('data-webchatDeploymentId');
        const webchatOrgId = liveagentButtonOnline.getAttribute('data-webchatOrgId');
        const webchatUrl = liveagentButtonOnline.getAttribute('data-webchatUrl');
        const webchatButtonId = liveagentButtonOnline.getAttribute('data-webchatButtonId');
        const webchatService = liveagentButtonOnline.getAttribute('data-webchatService');

        liveagent.init(webchatUrl, webchatchatDeploymentId, webchatOrgId);

        if (!window._laq) {
            window._laq = [];
        }

        window._laq.push(() => {
            liveagent.showWhenOnline(webchatButtonId, liveagentButtonOnline);
            liveagent.showWhenOffline(webchatButtonId, document.getElementById('liveagent_button_offline'));
            liveagent.addCustomDetail('Service', webchatService, false);
        });
    }
}
